import React from "react";
import "./index.scss";
export const IntroService = ({ items, img }) => {
  return (
    <div className="introService">
      <div className="introService-container mt-5 mb-5">
        <div className="row  g-3 w-100 align-items-center mt-5 justify-content-center ms-0">
          <div className="col-12 col-md-6 ">
            <img src={img} alt="img" className="img-fluid" />
          </div>
          <div className="col-12 col-md-6 ">
            <div className="row ps-0 justify-content-center g-5 w-100 align-items-stretch ms-0">
              {items.map((item, index) => (
                <div className="col-12 col-md-6 d-flex">
                  <div className="avantage-card p-4">
                    <div className="icon mb-3">{item.icon}</div>
                    <p className="avantage-text mb-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
